import React from "react";
import {
	StyleSheet,
	View,
	Image
} from "react-native";

import Style from "ae-style";
import loadingGif from "../Resources/img/loading.gif";

const styles = StyleSheet.create({
	loader: {
		flex: 1,
		zIndex: 3,
		alignItems: "center",
		justifyContent: "center",
		backgroundColor: Style.colors.primary
	},
	canvas: {
		width: Style.imageSize.small,
		height: Style.imageSize.small,
	},
});

export default function Loader(){
	return (
		<View style={styles.loader}>
			<Image resizeMethod="resize" resizeMode="contain" style={styles.canvas} source={loadingGif} />
		</View>
	);
}